import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Twitter, Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Brand Section */}
        <div className="footer-brand">
          <div className="footer-logo-wrap">
            <img src="/logo.png" alt="Sympozium logo" className="footer-logo" />
            <span className="footer-logo-text">Sympozium</span>
          </div>
          <p className="footer-tagline">
            Transform Your Body. Redefine Your Confidence.
          </p>
          <div className="footer-social">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><Instagram size={18} /></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"><Facebook size={18} /></a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><Twitter size={18} /></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-links-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Contact Section */}
        <div className="footer-contact">
          <h4>Get In Touch</h4>
          <ul>
            <li>
              <Mail size={16} />
              <a href="mailto:help@sympozium.life">help@sympozium.life</a>
            </li>
            <li>
              <Phone size={16} />
              <a href="tel:+917396794767">+91 7396794767</a>
            </li>
            <li>
              <MapPin size={16} />
              <span>Hyderabad, India</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© {currentYear} Sympozium. All rights reserved.</p>
        <div className="footer-legal">
          <a href="#">Privacy Policy</a>
          <span>•</span>
          <a href="#">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
